import request from '@/utils/request'

// 修改基本信息
export function modifyUserInformation (data) {
  return request({
    url: '/api/manage/v1/manager/profile/modify',
    method: 'post',
    data
  })
}
// 修改密码
export function modifyUserPassword (data) {
  return request({
    url: '/api/manage/v1/manager/profile/password',
    method: 'post',
    data
  })
}